<div class="map-content">
  <app-map (markerClicked)="onMarkerClicked($event)"
           [gestures]="gestures"></app-map>
</div>
